import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AccountantService } from "src/app/services/accountatnt/accountant.service";

export interface AccountantClient {
  companyId: number;
  accessGuid: string;
  companyName: string;
  fantasyName: string;
  cnpj: string;
  email: string;
}

@Component({
  selector: "app-accountant-page",
  templateUrl: "./accountant-page.component.html",
  styleUrls: ["./accountant-page.component.scss"],
})
export class AccountantPageComponent implements OnInit {
  showCode = false;
  isAuthenticated = false;
  accountantForm: FormGroup;
  isLoading = false;

  accountantName: string = '';
  accountantEmail: string = '';
  accountantDocument: string = '';
  clients: AccountantClient[] = [];
  displayedColumns: string[] = ['companyName', 'fantasyName', 'cnpj', 'email', 'action'];

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private accountantService: AccountantService,
    private router: Router
  ) {
    this.accountantForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      codigo: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.accountantForm.get('codigo')?.disable();

    // Restaurar estado de autenticação ao voltar
    const savedState = sessionStorage.getItem('accountantAuthState');
    if (savedState) {
      try {
        const state = JSON.parse(savedState);
        this.isAuthenticated = state.isAuthenticated;
        this.accountantName = state.accountantName;
        this.accountantEmail = state.accountantEmail;
        this.accountantDocument = state.accountantDocument;
        this.clients = state.clients || [];
      } catch (error) {
        console.error('Erro ao restaurar estado:', error);
      }
    }
  }

  async onSendCode() {
    
    if (this.accountantForm.get('email')?.invalid) {
      this.snackBar.open("Por favor, insira um email válido.", "", {
        duration: 3000,
        verticalPosition: "top",
        panelClass: ["red-snackbar"],
      });
      return;
    }

    this.isLoading = true;
    const email = this.accountantForm.get('email')?.value;

    try {
      const response = await this.accountantService.sendCode(email);
      
      if (response.success) {
        this.showCode = true;
        this.accountantForm.get('email')?.disable();
        this.accountantForm.get('codigo')?.enable();
        
        this.snackBar.open("Verifique o código enviado para o seu email.", "", {
          duration: 3000,
          verticalPosition: "top",
          panelClass: ["green-snackbar"],
        });
      } else {
        this.snackBar.open(response.message || "Erro ao enviar código.", "", {
          duration: 3000,
          verticalPosition: "top",
          panelClass: ["red-snackbar"],
        });
      }
    } catch (error) {
      this.snackBar.open("Erro ao enviar código. Tente novamente.", "", {
        duration: 3000,
        verticalPosition: "top",
        panelClass: ["red-snackbar"],
      });
    } finally {
      this.isLoading = false;
    }
  }

  async onSendSignup(e: Event) {
    e.preventDefault();
    
    if (this.accountantForm.get('email')?.invalid) {
      this.snackBar.open("Por favor, insira um email válido.", "", {
        duration: 3000,
        verticalPosition: "top",
        panelClass: ["red-snackbar"],
      });
      return;
    }

    this.isLoading = true;
    const email = this.accountantForm.get('email')?.value;
    const code = this.accountantForm.get('codigo')?.value;

    try {
      const response = await this.accountantService.sendSignup(email, code);
      
      if (response.success) {
        this.isAuthenticated = true;
        this.accountantName = response.data.name;
        this.accountantEmail = response.data.email;
        this.accountantDocument = response.data.document;
        this.clients = response.data.clients || [];

        this.saveAuthState();
      } else {
        this.snackBar.open(response.message || "Código Inválido.", "", {
          duration: 3000,
          verticalPosition: "top",
          panelClass: ["red-snackbar"],
        });
      }
    } catch (error) {
      this.snackBar.open("Código inválido. Tente novamente.", "", {
        duration: 3000,
        verticalPosition: "top",
        panelClass: ["red-snackbar"],
      });
    } finally {
      this.isLoading = false;
    }
  }

  private saveAuthState(): void {
    const state = {
      isAuthenticated: this.isAuthenticated,
      accountantName: this.accountantName,
      accountantEmail: this.accountantEmail,
      accountantDocument: this.accountantDocument,
      clients: this.clients
    };
    sessionStorage.setItem('accountantAuthState', JSON.stringify(state));
  }

  onAccessClient(client: AccountantClient): void {
    this.saveAuthState();
    
    this.router.navigate(['/authentication'], {
      queryParams: { guid: client.accessGuid }
    });
  }
}
